import './descuentos.css';

const Descuentos = () => {

    return(
        <div>
            Aqui van los descuentos
        </div>
    )
}

export default Descuentos;